import { Applicant } from '@flatsy/types/Applications/Applicant'
import { useSelector } from 'react-redux'
import { RootState } from 'src/redux'
import { selectApplicantById, selectApplicants } from 'src/redux/slices/Applicant/Selector'

export const useApplicantsSelector = (): Applicant[] | undefined => {
  const applicants = useSelector<RootState, Applicant[] | undefined>((state) =>
    selectApplicants(state)
  )

  return applicants
}

export const useApplicantById = (applicantId?: string): Applicant | undefined => {
  const applicant = useSelector((state: RootState) => selectApplicantById(state, applicantId || ''))
  if (applicantId && applicantId !== '') {
    return applicant
  }
  return undefined
}
